import * as React from 'react';
import { debounce } from 'lodash';

import FamilyTypeaheadContainer from './FamilyTypeaheadContainer';
import FamilyTypeaheadInput from './FamilyTypeaheadInput';

const MIN_QUERY_LENGTH = 2;
const SEARCH_NETWORK_LIMIT_MS = 800; // for debounce

type Props = {
  allowDirectAdd: boolean;
  relation: 'parent' | 'child';
  onSelectFamilyMember: (familyMember: any) => void;
  onDirectAddClick: (query: string) => void;
};

type State = {
  query: string;
};

export default class FamilyTypeahead extends React.Component<Props, State> {
  state = {
    query: '',
  };

  handleQueryChange = debounce(
    (query: string) => {
      this.setState({ query });
    },
    SEARCH_NETWORK_LIMIT_MS,
    { trailing: true }
  );

  handleSelection = (user: any) => {
    this.setState({ query: user.name });
    this.props.onSelectFamilyMember(user);
  };

  isMinQueryLength = () => {
    return this.state && this.state.query.length > MIN_QUERY_LENGTH;
  };

  render() {
    return (
      <FamilyTypeaheadContainer
        isMinQueryLength={this.isMinQueryLength()}
        query={this.state.query}
        relation={this.props.relation}
      >
        {({ loading, familyMembers }) => (
          <FamilyTypeaheadInput
            loading={loading}
            // @ts-expect-error
            familyMembers={familyMembers}
            allowDirectAdd={this.props.allowDirectAdd && this.props.relation === 'parent'}
            isMinQueryLength={this.isMinQueryLength()}
            onDirectAddClick={this.props.onDirectAddClick}
            query={this.state.query}
            onQueryChange={this.handleQueryChange}
            onSelectFamilyMember={this.handleSelection}
          />
        )}
      </FamilyTypeaheadContainer>
    );
  }
}
